import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'app-local-spinner',
    templateUrl: './local-spinner.component.html',
    styleUrls: ['./local-spinner.component.scss']
})
export class LocalSpinnerComponent {
    @Input() loadingText: string = 'Processing...';
    @Input() showText: boolean = true;
    @Input() blur: boolean = true;
    @Input() size: 'small' | 'medium' | 'large' = 'large';
    @Input() stickyCenter: boolean = false;

    // When stickyCenter=true, the host element must NOT capture pointer events
    // so that elements behind it (like the sticky header) remain clickable.
    @HostBinding('style.pointer-events')
    get hostPointerEvents(): string {
        return this.stickyCenter ? 'none' : 'auto';
    }
}
